"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveCartResponseMapper = void 0;
var SaveCartResponseMapper = /** @class */ (function () {
    function SaveCartResponseMapper(data) {
        this.localData = data;
    }
    SaveCartResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return SaveCartResponseMapper;
}());
exports.SaveCartResponseMapper = SaveCartResponseMapper;
//# sourceMappingURL=SaveCartResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/SaveCartResponseMapper.js
// module id = 2061
// module chunks = 8